import {NavigationService} from '../../Services/NavigationService';
import {StateParams} from 'angular-ui-router';
import {TimeEntryDialog} from '../../Models/time-entry-dialog';
import {ScannerService} from '../../Services/ScannerService';
import {EAppUserType, EExternalProjectType, EKind, ITimeBookingDetailVm, ITimeEntryTypeVm} from '../../Data/Data';
import {BookingDataService} from '../../Services/BookingDataService';
import {TimeEntryDataService} from '../../Services/TimeEntryDataService';
import {Triarc} from '../../../Cirrus/utils/CommonUtils';
import {DateController} from '../../Models/date-controller';
import {Form} from '../../Models/form';
import {SaveDialog} from '../../Models/save-dialog';
import {DeleteDialog} from '../../Models/delete-dialog';
import {IPromise} from 'angular';
import {WaitDialog} from '../../Models/wait-dialog';
import {TerminalSessionService} from '../../Services/TerminalSessionService';
import {AuthenticationService} from "../../Services/AuthenticationService";

export class BookingDetailController extends DateController {
  static controllerId = "BookingDetailController";
  static $inject = [
    '$scope',
    '$stateParams',
    NavigationService.serviceId,
    ScannerService.serviceId,
    TimeEntryDataService.serviceId,
    BookingDataService.serviceId,
    TerminalSessionService.serviceId,
    AuthenticationService.serviceId,
  ];

  private readonly userId: number;
  private readonly bookingId: string;

  loading = true;

  form = new Form();
  booking: ITimeBookingDetailVm;

  timeEntryKind = EKind.Work;
  timeEntry: ITimeEntryTypeVm;

  waitDialog = new WaitDialog();
  deleteDialog = new DeleteDialog();
  saveDialog = new SaveDialog();
  timeEntryDialog = new TimeEntryDialog();

  projKinds = [EKind.Work];

  constructor(private $scope: ng.IScope,
              $stateParams: StateParams,
              private navigation: NavigationService,
              private scanner: ScannerService,
              private timeEntryData: TimeEntryDataService,
              private bookingData: BookingDataService,
              private session: TerminalSessionService,
              private auth: AuthenticationService) {
    super($scope);

    this.userId = parseInt($stateParams['userId']);
    this.bookingId = $stateParams['bookingId'] || null;

    if (this.isNew) {
      this.booking = <ITimeBookingDetailVm>{
        id: Triarc.generateGuid(),
        project: {id: null, externalId: null, externalType: EExternalProjectType.Proj, label: ''},
        employee: {id: this.userId, externalId: null, label: ''},
        employeeId: this.userId,
      };
      this.timeEntryData.getDefault(this.timeEntryKind).then(timeEntry => {
        this.$scope.$apply(() => {
          this.booking.timeEntryType = {id: timeEntry.id, externalId: 0, label: ''};
          this.timeEntry = timeEntry;
          this.loading = false;
        });
      });
    } else {
      this.bookingData.get(this.bookingId).then(booking => {
        this.booking = booking;
        this.date = booking.from;
        this.timeFrom = booking.from;
        this.timeTo = booking.to;
        this.timeEntryData.getEntryType(this.booking.timeEntryTypeId).then(timeEntry => {
          this.$scope.$apply(() => {
            this.timeEntry = timeEntry;
            this.loading = false;
          });
        });
      });
    }

    this.form.add('date', () => this.date)
      .isRequired();

    this.form.add('timeFrom', () => this.booking.from)
      .isRequired()
      .isSmaller(() => this.booking.to);

    this.form.add('timeTo', () => this.booking.to)
      .isRequired()
      .isGreater(() => this.booking.from);

    this.form.add('projectno', () => this.booking.project.externalId)
      .isRequired();

    this.form.add('timeentry', () => this.booking.timeEntryType.id)
      .isRequired();
  }

  canSelectType() {
    return this.session.canSelectType();
  }

  get isNew() {
    return this.bookingId === null || this.bookingId === undefined;
  }

  get projectLocked() {
    return !this.isNew;
  }

  goBack() {
    this.navigation.goToState('booking-list', {userId: this.userId});
  }

  openTimeEntryDialog() {
    this.timeEntryDialog.open(val => {
      this.booking.timeEntryType = {id: val.id, externalId: 0, label: ''};
      this.timeEntry = val;
    });
  }

  async scanProjectNo() {
    this.waitDialog.open('Scanner wird geladen...', () => this.scanner.scanProject()).then(result => {
      this.$scope.$apply(() => {
        this.booking.project = {
          id: 0,
          externalId: result.value,
          externalType: result.type,
          label: ''
        };
      });
    });
  }

  save() {
    if (!this.form.isValid()) {
      return;
    }

    let factory: () => IPromise<any>;
    if (this.isNew) {
      factory = () => this.bookingData.create(this.booking);
    } else {
      factory = () => this.bookingData.save(this.booking);
    }

    this.saveDialog.open(factory).then(() => {
      this.goBack();
    });
  }

  delete() {
    const factory: any = () => this.bookingData.delete(this.bookingId);
    this.deleteDialog.open(factory).then(res => {
      if (res) {
        this.goBack();
      }
    });
  }

  fromChanged(date: Date): void {
    if (this.booking) {
      this.booking.from = date;
    }
  }

  toChanged(date: Date): void {
    if (this.booking) {
      this.booking.to = date;
    }
  }
}
